import { useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { pendingChatDraft } from "@/lib/chatDrafts";

// Wraps save/close handlers: if a chat message is typed but not sent, ask to send or discard first.
export function useUnsentChatGuard() {
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);
  const guard = (fn) => (...args) => {
    const draft = pendingChatDraft();
    if (!draft) return fn(...args);
    setPending({ draft, next: () => fn(...args) });
  };
  const sendThen = async () => {
    setBusy(true);
    const ok = await pending.draft.send();
    setBusy(false);
    if (!ok) return;
    const { next } = pending; setPending(null); next();
  };
  const discardThen = () => { pending.draft.discard(); const { next } = pending; setPending(null); next(); };
  const dialog = (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
      <AlertDialogContent data-testid="unsent-chat-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>You have an unsent chat message</AlertDialogTitle>
          <AlertDialogDescription className="line-clamp-3">"{pending?.draft.preview}"</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => setPending(null)} data-testid="unsent-chat-keep">Keep editing</Button>
          <Button variant="outline" onClick={discardThen} className="border-red-200 text-red-600 hover:bg-red-50" data-testid="unsent-chat-discard">Discard</Button>
          <Button onClick={sendThen} disabled={busy} className="bg-sky-600 hover:bg-sky-700" data-testid="unsent-chat-send">{busy ? "Sending…" : "Send message"}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return [guard, dialog];
}
